import clienteDialogReducer from './clienteDialogReducer';

export default clienteDialogReducer;